import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import { getBusinessYearsTable } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/businessYears',
  initialState: {
    isLoading: true,
    data: {},
    ids: [],
    totalCompaniesQuantity: undefined,
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.data = {}
      state.ids = []
      state.totalCompaniesQuantity = undefined
    },
    filterTable: (state, { payload }) => {
      let ids = Object.keys(state.data).filter(
        (id) => state.data[id].yearsOfOperation === payload,
      )
      state.ids = ids
    },
    resetTable: (state) => {
      state.ids = Object.keys(state.data)
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getBusinessYearsTable.pending, (state) => {
      state.isLoading = true
      state.data = {}
      state.ids = []
      state.totalCompaniesQuantity = undefined
    })
    builder.addCase(
      getBusinessYearsTable.fulfilled,
      (state, { payload = {} }) => {
        state.isLoading = false

        const { data = [], totalCompanies } = payload
        const formatData = data.map((item, index) => ({
          ...item,
          id: index + 1,
        }))
        const ids = formatData.map((item) => item.id)

        state.ids = ids
        state.data = keyBy(formatData, 'id')
        state.totalCompaniesQuantity = totalCompanies
      },
    )
    builder.addCase(getBusinessYearsTable.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectData = (state) => state[slice.name].data
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectIds = (state) => state[slice.name].ids
export const selectCellData = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
export const selectTopCompaniesQuantity = (state) =>
  state[slice.name].totalCompaniesQuantity

export const { filterTable, resetTable, resetStore } = slice.actions

register(slice.name, slice.reducer)
